import React from 'react';
import { useData } from '../context/DataContext';
import SEO from '../components/SEO';

const Awards = () => {
  const { awards } = useData();
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SEO 
        title="Awards & Recognition" 
        description="List of awards, prizes, and recognitions received by Leon Krykhtin."
        url="/awards"
      />
      <h2 className="text-3xl font-bold tracking-tighter uppercase mb-12">Awards</h2>
      
      <div className="space-y-12">
        {awards.map((award, index) => (
          <div key={index} className="flex flex-col md:flex-row md:items-baseline border-b border-neutral-200 pb-8 last:border-0 group">
            <span className="text-sm font-mono text-neutral-400 w-24 mb-2 md:mb-0">{award.year}</span>
            <div className="flex-1">
              <h3 className="text-xl font-bold uppercase tracking-tight mb-1 group-hover:text-neutral-600 transition-colors">
                {award.title}
              </h3>
              <div className="flex flex-col sm:flex-row sm:items-center text-neutral-500 text-sm">
                <span>{award.organizer}</span>
                <span className="hidden sm:inline mx-2">•</span>
                <span>{award.location}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Awards;
